import { Capacitor } from '@capacitor/core';
import { Browser } from '@capacitor/browser';
export const FLEET_ORIGIN='https://fleet.shonanpartner.com';
const KEY='big_taxi_company_driver_session_v1';
export function fleetSession(){try{return JSON.parse(localStorage.getItem(KEY)||'null');}catch{return null;}}
export function clearFleetSession(expectedToken){if(expectedToken!==undefined&&fleetSession()?.access_token!==expectedToken)return;localStorage.removeItem(KEY);window.dispatchEvent(new Event('fleet-driver-session-changed'));}
export function saveFleetSession(value){localStorage.setItem(KEY,JSON.stringify(value));window.dispatchEvent(new Event('fleet-driver-session-changed'));}
export async function fleetRequest(method,path,body,params={}){
 if(typeof path!=='string'||!path.startsWith('/driver/')||/[\\#]/.test(path))throw new Error('Invalid company endpoint');
 const url=new URL('/api'+path,FLEET_ORIGIN);
 if(url.origin!==FLEET_ORIGIN||!url.pathname.startsWith('/api/driver/')||decodeURIComponent(url.pathname)!==url.pathname)throw new Error('Invalid company endpoint');
 Object.entries(params).forEach(([key,value])=>url.searchParams.set(key,value));
 const token=fleetSession()?.access_token;
 const controller=new AbortController();const timeout=setTimeout(()=>controller.abort(),path==='/driver/orders/parse'?55000:15000);
 try{
  const response=await fetch(url,{method:method.toUpperCase(),credentials:'omit',cache:'no-store',signal:controller.signal,
   headers:{'Content-Type':'application/json',...(token?{Authorization:`Bearer ${token}`}:{})},
   ...(body===undefined?{}:{body:JSON.stringify(body)})});
  const value=await response.json();
  // An older account's response must neither populate the current view nor revoke its session.
  if(fleetSession()?.access_token!==token)throw new Error('Account session changed; please reload.');
  if(!response.ok){
   if(path!=='/driver/login'&&(response.status===401||(response.status===403&&['COMPANY_NOT_ACTIVE','PLATFORM_DISABLED','COMPANY_DISABLED','ACCOUNT_NOT_ACTIVATED','ACCOUNT_EXPIRED'].includes(value.detail))))clearFleetSession();
   const error=new Error(typeof value.detail==='string'?value.detail:'Please check the entered information');
   error.response={status:response.status,data:value};throw error;
  }
  return value;
 }finally{clearTimeout(timeout);}
}
export const fleetAttendanceRequest=(method,path,body,params)=>fleetRequest(method,'/driver/attendance'+path,body,params);
export async function openFleetPdf(path){
 if(!/^\/api\/driver\/(document-pdf\/|daily-report-pdf\/|payslips\/)/.test(path))throw new Error('Invalid download');
 const result=await fleetRequest('POST','/driver/download-ticket',{path});
 const url=new URL(result.url,FLEET_ORIGIN);
 if(url.origin!==FLEET_ORIGIN)throw new Error('Invalid download host');
 if(Capacitor.isNativePlatform())await Browser.open({url:url.href});
 else window.open(url.href,'_blank','noopener,noreferrer');
}
